import { createApi } from '@reduxjs/toolkit/query/react';
import { BaseQueryWithReAuth, HES_TAG_TYPES } from '../utils';
import { scheduledReportsEndpoints } from './endpoints/scheduled-reports';
import { deviceManagementEndpoints } from './endpoints/device-management';
import { meterProfileData } from './endpoints/meter-profile-data';
import { commandExecutionEndpoints } from './endpoints/command-execution';
import { deviceInfoEndpoints } from './endpoints/device-info';
import { configureCommandEndpoints } from './endpoints/configure-command';
import { loginEndpoints } from './endpoints/login';
import { downloadDataEndpoints } from './endpoints/download-data';
import { alarmsEndPoints } from './endpoints/alarms';
import { pushEventsEndpoints } from './endpoints/push-events';
import { TODEndpoints } from './endpoints/meter-profile-data/tod';

const hesBaseQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_HES_BASE_URL}/${
    import.meta.env.VITE_HES_API_VERSION
  }/`,
  credentials: 'same-origin',
  setHeaders: (headers, { endpoint }) => {
    if (endpoint === 'updateTokenForAuth') {
      headers.set(
        'Authorization',
        `Bearer ${localStorage.getItem('accessToken')}` as string
      );
    } else {
      headers.set(
        'Authorization',
        `Bearer ${localStorage.getItem('hes_token')}` as string
      );
    }
    headers.set(
      'access-token',
      `Bearer ${localStorage.getItem('accessToken')}` as string
    );
    headers.set('X-Id-Token', localStorage.getItem('idToken') as string);
    return headers;
  }
});

const hesApi = createApi({
  reducerPath: 'hesApi',
  baseQuery: hesBaseQuery,
  tagTypes: HES_TAG_TYPES,
  endpoints: (builder) => ({
    ...deviceManagementEndpoints(builder),
    ...meterProfileData(builder),
    ...scheduledReportsEndpoints(builder),
    ...commandExecutionEndpoints(builder),
    ...deviceInfoEndpoints(builder),
    ...configureCommandEndpoints(builder),
    ...loginEndpoints(builder),
    ...downloadDataEndpoints(builder),
    ...alarmsEndPoints(builder),
    ...pushEventsEndpoints(builder),
    ...TODEndpoints(builder)
  })
});

export const {
  useLazyGetLocationHierarchyQuery,
  useLazyGetDeviceIdentifierQuery,
  useGetDeviceMetaInfoMetricsQuery,
  useGetLiveDataMetricsQuery,
  useGetBlockLoadPushDataQuery,
  useGetDailyLoadPushDataQuery,
  useGetMonthlyBillingDataQuery,
  useGetScheduledReportsQuery,
  useGetProfileInstantDataQuery,
  useGetDeviceSubCategoryQuery,
  useGetPeriodicPushDataQuery,
  useLazyGetCommandInfoQuery,
  useGetCommandInfoQuery,
  useGetCommandExecutionHistoryQuery,
  useLazyGetBatchCommandExecutionHistoryQuery,
  useExecuteCommandMutation,
  useGetDeviceInfoQuery,
  useLazyGetDeviceInfoQuery,
  useUpdateDeviceInfoMutation,
  useGetConfigureCommandInfoQuery,
  useUpdateCommandInfoMutation,
  useUpdateTokenForAuthMutation,
  useGetCommandExecutionHistoryDetailsQuery,
  useUploadCSVfileMutation,
  useLazyDownloadCSVDataQuery,
  useGetRestorationOccuranceMetricsQuery,
  useUploadFileWithProgressMutation,
  useGetAlarmsEventDetailsQuery,
  useGetAlarmsEventGraphsQuery,
  useGetPushEventsQuery,
  useGetMeterRelayStatusListViewQuery,
  useGetMeterRelayStatusGraphViewQuery,
  useGetRealtimeClockListViewQuery,
  useLazyGetRFDeviceDetailsQuery,
  useGetNamePlateDetailDataQuery,
  useLazyDownloadCommandResponsePayloadQuery,
  useGetEventsFiltersDropdownQuery,
  useLazyDownloadAlarmsDataQuery,
  useGetDeviceIdentifiersFromBatchIdQuery,
  useUploadFactoryFileMutation,
  useGetSourceListQuery,
  useGetUserEmailIdListQuery,
  useGetDeviceMakeListQuery,
  useLazyDownloadAllDeviceInfoDataQuery,
  useLazyDownloadBatchExecHistoryQuery,
  useLazyGetDCUSerialQuery,
  usePingTestMutation,
  useGetMeterStatisticsQuery,
  useLazyDownloadMeterStatisticsCSVDataQuery,
  useLazyDownloadRTCDataQuery,
  useLazyDownloadFactoryFileFormatQuery,
  useGetTODEnergyListQuery,
  usePrefetch
} = hesApi;

export default hesApi;
